/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApplicationScope,
} from '../models';
import {
    ApplicationScopeFromJSON,
    ApplicationScopeToJSON,
} from '../models';

export interface DeactivateAccountRequest {
    xApplicationScope: ApplicationScope;
}

export interface DeleteAccountRequest {
    xApplicationScope: ApplicationScope;
}

export interface ReactivateAccountRequest {
    xApplicationScope: ApplicationScope;
}

export interface SetReadOnlyForOtherAccountRequest {
    xApplicationScope: ApplicationScope;
    id: string;
    readOnly: boolean;
}

/**
 * 
 */
export class AccountControllerApi extends runtime.BaseAPI {

    /**
     * deactivate account
     * deactivate account
     */
    async deactivateAccountRaw(requestParameters: DeactivateAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling deactivateAccount.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/accounts`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * deactivate account
     * deactivate account
     */
    async deactivateAccount(requestParameters: DeactivateAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deactivateAccountRaw(requestParameters, initOverrides);
    }

    /**
     * delete account
     * delete account
     */
    async deleteAccountRaw(requestParameters: DeleteAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling deleteAccount.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/accounts/fixed`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * delete account
     * delete account
     */
    async deleteAccount(requestParameters: DeleteAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteAccountRaw(requestParameters, initOverrides);
    }

    /**
     * reactivate account
     * reactivate account
     */
    async reactivateAccountRaw(requestParameters: ReactivateAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling reactivateAccount.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/accounts`,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * reactivate account
     * reactivate account
     */
    async reactivateAccount(requestParameters: ReactivateAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.reactivateAccountRaw(requestParameters, initOverrides);
    }

    /**
     * set read only for other account
     * set read only for other account
     */
    async setReadOnlyForOtherAccountRaw(requestParameters: SetReadOnlyForOtherAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling setReadOnlyForOtherAccount.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling setReadOnlyForOtherAccount.');
        }

        if (requestParameters.readOnly === null || requestParameters.readOnly === undefined) {
            throw new runtime.RequiredError('readOnly','Required parameter requestParameters.readOnly was null or undefined when calling setReadOnlyForOtherAccount.');
        }

        const queryParameters: any = {};

        if (requestParameters.readOnly !== undefined) {
            queryParameters['readOnly'] = requestParameters.readOnly;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/accounts/{id}/read-only`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * set read only for other account
     * set read only for other account
     */
    async setReadOnlyForOtherAccount(requestParameters: SetReadOnlyForOtherAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.setReadOnlyForOtherAccountRaw(requestParameters, initOverrides);
    }

}
